/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { OrderCleansingDto, OrderCleansingUpdateRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class OrderCleansingService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 특정 주문 클렌징 정보를 통관 타이틀과 함께 업데이트합니다.
   *
   * @tags OrderCleansingService
   * @name UpdateOrderCleansing
   * @summary Update Order Cleansing with Customs Title
   * @request PUT:/v1/order-cleansing/{orderCleansingId}/verify
   * @secure
   */
  updateOrderCleansing = (
    orderCleansingId: number,
    data: OrderCleansingUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<OrderCleansingDto, any>({
      path: `/v1/order-cleansing/${orderCleansingId}/verify`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description 주문 클렌징 목록을 조회합니다.
   *
   * @tags OrderCleansingService
   * @name GetOrderCleansings
   * @summary Get Order Cleansing List
   * @request GET:/v1/order-cleansing
   * @secure
   */
  getOrderCleansings = (
    query?: {
      /** @format int64 */
      categoryId?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      status?:
        | 'RECEIVED'
        | 'PROCESSING'
        | 'CLEANSED'
        | 'VALIDATION_ERROR'
        | 'USER_VERIFIED'
        | 'TRANSMISSION_FAILED'
        | 'COMPLETED';
      searchFieldName?: string;
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["id,ASC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<OrderCleansingDto[], any>({
      path: `/v1/order-cleansing`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OrderCleansingService
   * @name GetOrderCleansing
   * @summary Get Order Cleansing by ID
   * @request GET:/v1/order-cleansing/{orderCleansingId}
   * @secure
   */
  getOrderCleansing = (
    orderCleansingId: number,
    query?: {
      /** @format int64 */
      categoryId?: number;
      /** @format date */
      startDate?: string;
      /** @format date */
      endDate?: string;
      status?:
        | 'RECEIVED'
        | 'PROCESSING'
        | 'CLEANSED'
        | 'VALIDATION_ERROR'
        | 'USER_VERIFIED'
        | 'TRANSMISSION_FAILED'
        | 'COMPLETED';
      searchFieldName?: string;
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["id,ASC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<OrderCleansingDto, any>({
      path: `/v1/order-cleansing/${orderCleansingId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
